import AddPageDialog from "../../../components/add-page.dialog";
import { FormItem, FormType } from "../../../components/form/form-generator";
import { FileUploadCategory } from "../../../services/file-upload.service";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { createEndPage } from "../apis/end-page.api";
import { EndPageCreateEntity } from "../entities/end-page-create.entity";
import { EndPageCreateModel } from "../models/end-page-create.model";

const formElements: FormItem[] = [
  {
    title: "Description",
    contentKey: "description",
    type: FormType.textArea,
  },
];

export default function AddEndPageDialog({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const setAlert = useDashboardStore((state) => state.setAlert);
  const onSave = async (values: any) => {
    createEndPage(EndPageCreateModel.fromEntity(values))
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        setAlert({
          message: error.response.data.message,
          type: AlertType.error,
        });
      });
  };

  return (
    <AddPageDialog
      title="Add End Page"
      open={open}
      setOpen={setOpen}
      page={EndPageCreateEntity.createEmpty()}
      formElements={formElements}
      onSaveClick={onSave}
      uploadCategory={FileUploadCategory.END}
    />
  );
}
